import LogUserCommonValueObject from './LogUserCommonValueObject.js'
import UserDataCommonValueObject from './UserDataCommonValueObject.js'

export default class CommonValueObjectsFactory {
  static logUserCommonValueObject = properties => {
    return new LogUserCommonValueObject(properties)
  }

  static userDataCommonValueObject = properties => new UserDataCommonValueObject(properties)
}
